import { z } from "zod";
import { getMultipleStoriesFromGlobalStoryblokStoriesByComponentType } from "../utils/global-story-functions";
import { useGlobalStoryblokStories } from "../utils/with-global-story";

const washingInstructionSchema = z.object({
  heading: z.string().optional(),
  instructions: z
    .object({
      text: z.string().optional(),
    })
    .array(),
});

export type WashingInstruction = z.infer<typeof washingInstructionSchema>;

export const useWashingInstruction = (): WashingInstruction | undefined => {
  const globalStoryblokStories = useGlobalStoryblokStories();
  const stories = getMultipleStoriesFromGlobalStoryblokStoriesByComponentType(
    "WashingInstruction",
    globalStoryblokStories,
  );

  return stories.map((story) => washingInstructionSchema.parse(story))[0];
};
